
    import { injectNav, injectFooter } from './src/scripts/layout.js';
    import { initScrollAnimations } from './src/scripts/animations.js';
    import { initContactForm } from './src/scripts/contact-form.js';
    document.addEventListener('DOMContentLoaded', () => {
      injectNav();
      injectFooter();
      initScrollAnimations();
      initContactForm();

      // Read estimator parameters from URL query string
      const urlParams = new URLSearchParams(window.location.search);
      const estPrice = urlParams.get('est_price');
      const estDesc = urlParams.get('est_desc');

      if (estPrice && estDesc) {
        const descField = document.getElementById('field-description');
        const budgetField = document.getElementById('field-budget');
        const typeField = document.getElementById('field-project-type');

        if (descField) {
          descField.value = `I used the website Project Estimator and configured the following:\n${estDesc}\n\nEstimated Price: ${estPrice}\n\nPlease get in touch to finalize this project.`;
        }

        if (budgetField) {
          const budgetText = estPrice.replace(/[^\d]/g, '');
          const val = parseInt(budgetText);
          if (val < 10000) {
            budgetField.value = "Under ₹10,000";
          } else if (val >= 10000 && val < 25000) {
            budgetField.value = "₹10,000 - ₹25,000";
          } else if (val >= 25000 && val < 50000) {
            budgetField.value = "₹25,000 - ₹50,000";
          } else if (val >= 50000 && val < 100000) {
            budgetField.value = "₹50,000 - ₹1,00,000";
          } else if (val >= 100000) {
            budgetField.value = "₹1,00,000+";
          }
        }

        if (typeField) {
          if (estDesc.includes('Type: logo')) typeField.value = "Logo & Branding";
          else if (estDesc.includes('Type: landing') || estDesc.includes('Type: corporate') || estDesc.includes('Type: ecommerce')) typeField.value = "Website Development";
          else if (estDesc.includes('Type: app')) typeField.value = "App Development";
        }
      }

      // Quick Callback Form Submission Handler
      const cbForm = document.getElementById('quick-callback-form');
      if (cbForm) {
        cbForm.addEventListener('submit', (e) => {
          e.preventDefault();
          const phone = document.getElementById('cb-phone').value;
          const status = document.getElementById('cb-status');
          status.style.display = 'block';
          status.textContent = 'Submitting...';
          status.style.color = 'var(--muted)';

          const formData = new FormData();
          formData.append('name', 'Quick Callback Lead');
          formData.append('email', 'callback@razaek.com');
          formData.append('phone', phone);
          formData.append('project_type', 'Quick Callback');
          formData.append('budget', 'N/A');
          formData.append('description', 'Requested a callback in 10-30 minutes from Contact Page Callback widget.');

          fetch('./submit-contact.php', {
            method: 'POST',
            body: formData
          })
          .then(res => res.json())
          .then(data => {
            if (data.success) {
              window.location.href = './thank-you.html';
            } else {
              status.textContent = '❌ ' + (data.message || 'Submission failed.');
              status.style.color = '#dc2626';
            }
          })
          .catch(() => {
            status.textContent = '❌ Server connection failed.';
            status.style.color = '#dc2626';
          });
        });
      }
    });
  